import { compareDate } from "./compareDate";

export const getPrice =  (fullPrice, discount) => {
    return Number(fullPrice) - (Number(fullPrice) * Number(discount) / 100);
}

export const finalPrice = (order) => {
    const inSale = compareDate(order.card?.discountEndedAt)
    const finalPrice = inSale && order.card?.discount ? getPrice(order.card?.price, order.card?.discount) : order.card?.price
    return finalPrice
}